(function() {
    'use strict';
    /**
     Enhances an element and generates
     @param wrapper DOM Object
     @param content Object with translations and content to be created in popup
     @private


    //Content object example
    {
        translations: {
            title: 'popup title',
            summary: 'popup summary introduction',
            exclusions: 'popup insurance exclusions'
        },
        links: {
            summary: {
                text: 'summary pdf link',
                link: 'www.google.es'
            },
            extended: {
                text: 'extended pdf link',
                link: 'www.google.es'
            }
        },

        dualcontract: {
            enabled: true,
            title: 'dual contract title text',
            opener: 'dual contract link opener',
            text: 'dual contract conditions text'
        }
    }
     */

    Odigeo.UIElements.enhanceConditionsPopup = function(wrapper, content, tracking, newOptions) {
        var $wrapper = (wrapper instanceof $) ? wrapper : $(wrapper);
        var $popupTitle;
        var $popupTitleIcon;
        var $popupContent;
        var $popupContentTitle;
        var $popupIntro;
        var $popupLinksContainer;
        var $popupLinksSummary;
        var $popupLinksExtended;
        var $popupLinksDisclosure;
        var $popupExclusions;
        var $popupOpacityLayer;
        var addDualContract;
        var linkSummary;
        var linkExtended;
        var linkDisclosure;
        var linkTrackings = tracking || {};
        var sendTracking;
        let $popupModalLegendUk;
        let $popupLinkLegendUk;
        var options = {
            linkFontSizeModifierClass: '',
            wrapperModifierClass: '',
            popupIntroModifierClass: '',
            popupDualContractContainerModifierClass: '',
            popupContentTitleModifierClass: '',
            popupExclusionsModifierClass: '',
            popupModalLegendUkValue: '',
        };
        options = $.extend(true, options, newOptions);

        if ($wrapper.attr('data-skip-enhance') === 'true' || Odigeo._.isEmpty(content)) {
            return;
        }
        $wrapper.attr({'data-skip-enhance': true});

        $wrapper.addClass('od-modals-popup-media');

        sendTracking = function(conditions) {
            if (!Odigeo._.isEmpty(linkTrackings) && Odigeo._.isFunction(linkTrackings.clickConditions)) {
                linkTrackings.clickConditions(conditions);
            }
        };

        addDualContract = function() {
            var $popupDualContractContainer;
            var $popupDualContractMore;
            var $popupDualContractInfo;
            var $popupDualContractTitle;
            var $popupDualContractLinkWrapper;

            $popupDualContractContainer = $('<div>', {'class': 'od-modal-popupinfo ' + options.popupDualContractContainerModifierClass});
            $popupDualContractLinkWrapper = $('<div>');
            $popupDualContractTitle = $('<span>', {'html': content.dualcontract.title});
            $popupDualContractMore = $('<span>', {'class': 'odf-link ' + options.linkFontSizeModifierClass, 'html': content.dualcontract.opener});
            $popupDualContractInfo = $('<div>', {'class': 'odf-hidden od-insurance-policy-text-extra', 'html': content.dualcontract.text});
            $popupDualContractLinkWrapper.append($popupDualContractTitle, $popupDualContractMore);
            $popupDualContractContainer.append($popupDualContractLinkWrapper, $popupDualContractInfo);

            $popupDualContractMore.one(Odigeo.Events.tap, function(ev) {
                ev.stopPropagation();
                $popupDualContractMore.addClass('odf-hidden');
                $popupDualContractInfo.removeClass('odf-hidden');
                sendTracking('more');
            });

            $popupContent.append($popupDualContractContainer);
        };

        $wrapper.addClass('odf-box odf-box-layer odf-popup odf-popup-lg ' + options.wrapperModifierClass);

        // Popup Title
        $popupTitle = $('<div>', {'class': 'odf-box-layer-header', 'html': content.translations.title});
        $popupTitleIcon = $('<span>', {'class': 'odf-box-layer-close ficon hint_close', 'html': 'r'});
        $popupTitle.append($popupTitleIcon);

        // Popup Content
        $popupContent = $('<div>', {'class': 'odf-box-content od-modals-popup-scrollcontent'});

        if (content.translations.summaryTitle) {
            $popupContentTitle = $('<div>', {'class': 'popup_summary_title odf-bold odf-text-lg od-modal-popupinfo '
                + options.popupContentTitleModifierClass, 'html': content.translations.summaryTitle});
        }

        $popupIntro = $('<div>', {'class': 'popup_intro od-modal-popupinfo ' + options.popupIntroModifierClass,
            'html': content.translations.summary});

        // Popup Links
        linkSummary = content.links.summary;
        linkExtended = content.links.extended;
        linkDisclosure = content.links.disclosure;
        $popupLinksContainer = $('<div>', {'class': 'od-modal-popupinfo'});
        if (!Odigeo._.isEmpty(Odigeo._.get(linkSummary, 'link')) && !Odigeo._.isEmpty(Odigeo._.get(linkSummary, 'text'))) {
            $popupLinksSummary = $('<div>').append($('<a>', {
                'class': 'odf-link ' + options.linkFontSizeModifierClass,
                'href': linkSummary.link,
                'target': '_blank',
                'html': linkSummary.text,
            }));
            $popupLinksSummary.on(Odigeo.Events.tap, function(e) {
                e.stopPropagation();
                sendTracking('short');
            });
            $popupLinksContainer.append($popupLinksSummary);
        }
        if (!Odigeo._.isEmpty(Odigeo._.get(linkExtended, 'link')) && !Odigeo._.isEmpty(Odigeo._.get(linkExtended, 'text'))) {
            $popupLinksExtended = $('<div>').append($('<a>', {
                'class': 'odf-link ' + options.linkFontSizeModifierClass,
                'href': linkExtended.link,
                'target': '_blank',
                'html': linkExtended.text,
            }));
            $popupLinksExtended.on(Odigeo.Events.tap, function(e) {
                e.stopPropagation();
                sendTracking('long');
            });
            $popupLinksContainer.append($popupLinksExtended);
        }
        if (!Odigeo._.isEmpty(Odigeo._.get(linkDisclosure, 'link')) && !Odigeo._.isEmpty(Odigeo._.get(linkDisclosure, 'text'))) {
            $popupLinksDisclosure = $('<div>').append($('<a>', {
                'class': 'odf-link ' + options.linkFontSizeModifierClass,
                'href': linkDisclosure.link,
                'target': '_blank',
                'html': linkDisclosure.text,
            }));
            $popupLinksDisclosure.on(Odigeo.Events.tap, function(e) {
                e.stopPropagation();
                sendTracking('disclosure');
            });
            $popupLinksContainer.append($popupLinksDisclosure);
        }

        $popupExclusions = $('<div>', {'class': 'od-modal-popupinfo ' + options.popupExclusionsModifierClass,
            'html': content.translations.exclusions});
        $popupContentTitle ? $popupContent.append($popupContentTitle, $popupIntro, $popupLinksContainer, $popupExclusions) :
            $popupContent.append($popupIntro, $popupLinksContainer, $popupExclusions);

        // Dual contract
        if (content.dualcontract.enabled) {
            addDualContract();
        }

        // popupModalLegendUk
        if (options.popupModalLegendUkValue) {
            $popupLinkLegendUk = $('<span>').append($('<a>', {
                'class': 'odf-link odf-link-sm',
                'href': content.popupDisclaimerUk.linkUrlUk,
                'target': '_blank',
                'html': content.popupDisclaimerUk.linkTextUk,
            }));
            $popupModalLegendUk = $('<div>', {'class': 'od-modal-popupinfo odf-text odf-text-sm odf-text-mono-color-03 odf-space-outer-top-m',
                'html': Odigeo.Utils.replaceCmsKeyArgs(content.popupDisclaimerUk.textUk, $popupLinkLegendUk.html())});
            $popupModalLegendUk.on(Odigeo.Events.tap, function(e) {
                e.stopPropagation();
            });
            $popupContent.append($popupModalLegendUk);
        }

        // Popup Opacity Layer
        $popupOpacityLayer = $('<div>', {'class': 'od-modals-popup-bottom-opacitylayer'});
        $popupContent.append($popupOpacityLayer);

        $wrapper.append($popupTitle, $popupContent);

        return $wrapper;
    };

    Odigeo.UIElements.enhanceNewDualContractConditionsPopup = function(wrapper, content, tracking, newOptions) {
        let $wrapper = (wrapper instanceof $) ? wrapper : $(wrapper);
        let $popupTitle;
        let $popupTitleIcon;
        let $popupContent;
        let $popupContentTitle;
        let $popupIntro;
        let $firstLinkContainer;
        let $secondLinkContainer;
        let $popupLinksSummary;
        let $popupLinksExtended;
        let $popupLinksDisclosure;
        let $popupExclusions;
        let $popupOpacityLayer;
        let addDualContract;
        let linkSummary;
        let linkExtended;
        let linkDisclosure;
        let linkTrackings = tracking || {};
        let sendTracking;
        let options = {
            linkFontSizeModifierClass: '',
            wrapperModifierClass: '',
            popupIntroModifierClass: '',
            popupDualContractContainerModifierClass: '',
            popupContentTitleModifierClass: '',
            popupExclusionsModifierClass: '',
            popupModalLegendUkValue: '',
        };
        options = $.extend(true, options, newOptions);

        if ($wrapper.attr('data-skip-enhance') === 'true' || Odigeo._.isEmpty(content)) {
            return;
        }
        $wrapper.attr({'data-skip-enhance': true});

        $wrapper.addClass('od-modals-popup-media');

        sendTracking = function(conditions) {
            if (!Odigeo._.isEmpty(linkTrackings) && Odigeo._.isFunction(linkTrackings.clickConditions)) {
                linkTrackings.clickConditions(conditions);
            }
        };

        addDualContract = function() {
            let $popupDualContractContainer;
            let $popupDualContractMore;
            let $popupDualContractInfo;
            let $popupDualContractTitle;
            let $popupDualContractLinkWrapper;

            $popupDualContractContainer = $('<div>', {'class': 'od-modal-popupinfo ' + options.popupDualContractContainerModifierClass});
            $popupDualContractLinkWrapper = $('<div>');
            $popupDualContractTitle = $('<span>', {'html': content.dualcontract.title});
            $popupDualContractMore = $('<span>', {'class': 'odf-link ' + options.linkFontSizeModifierClass, 'html': content.dualcontract.opener});
            $popupDualContractInfo = $('<div>', {'class': 'odf-hidden od-insurance-policy-text-extra', 'html': content.dualcontract.text});
            $popupDualContractLinkWrapper.append($popupDualContractTitle, $popupDualContractMore);
            $popupDualContractContainer.append($popupDualContractLinkWrapper, $popupDualContractInfo);

            $popupDualContractMore.one(Odigeo.Events.tap, function(ev) {
                ev.stopPropagation();
                $popupDualContractMore.addClass('odf-hidden');
                $popupDualContractInfo.removeClass('odf-hidden');
                sendTracking('more');
            });

            $popupContent.append($popupDualContractContainer);
        };

        $wrapper.addClass('odf-box odf-box-layer odf-popup odf-popup-lg ' + options.wrapperModifierClass);

        // Popup Title
        $popupTitle = $('<div>', {'class': 'odf-box-layer-header', 'html': content.translations.title});
        $popupTitleIcon = $('<span>', {'class': 'odf-box-layer-close ficon hint_close', 'html': 'r'});
        $popupTitle.append($popupTitleIcon);

        // Popup Content
        $popupContent = $('<div>', {'class': 'odf-box-content od-modals-popup-scrollcontent'});

        if (content.translations.summaryTitle) {
            $popupContentTitle = $('<div>', {'class': 'popup_summary_title odf-bold odf-text-lg od-modal-popupinfo '
                    + options.popupContentTitleModifierClass, 'html': content.translations.summaryTitle});
        }

        $popupIntro = $('<div>', {'class': 'popup_intro od-modal-popupinfo ' + options.popupIntroModifierClass,
            'html': content.translations.summary});

        // Popup Links
        linkSummary = content.links.summary;
        linkExtended = content.links.extended;
        linkDisclosure = content.links.disclosure;
        $firstLinkContainer = $('<div>', {'class': 'od-modal-popupinfo'});
        $secondLinkContainer = $('<div>', {'class': 'od-modal-popupinfo'});
        if (!Odigeo._.isEmpty(Odigeo._.get(linkSummary, 'link')) && !Odigeo._.isEmpty(Odigeo._.get(linkSummary, 'text'))) {
            $popupLinksSummary = $('<div>').append($('<a>', {
                'class': 'odf-link ' + options.linkFontSizeModifierClass,
                'href': linkSummary.link,
                'target': '_blank',
                'html': linkSummary.text,
            }));
            $popupLinksSummary.on(Odigeo.Events.tap, function(e) {
                e.stopPropagation();
                sendTracking('short');
            });
            $firstLinkContainer.append($popupLinksSummary);
        }
        if (!Odigeo._.isEmpty(Odigeo._.get(linkExtended, 'link')) && !Odigeo._.isEmpty(Odigeo._.get(linkExtended, 'text'))) {
            $popupLinksExtended = $('<div>').append($('<a>', {
                'class': 'odf-link ' + options.linkFontSizeModifierClass,
                'href': linkExtended.link,
                'target': '_blank',
                'html': linkExtended.text,
            }));
            $popupLinksExtended.on(Odigeo.Events.tap, function(e) {
                e.stopPropagation();
                sendTracking('long');
            });
            $secondLinkContainer.append($popupLinksExtended);
        }
        if (!Odigeo._.isEmpty(Odigeo._.get(linkDisclosure, 'link')) && !Odigeo._.isEmpty(Odigeo._.get(linkDisclosure, 'text'))) {
            $popupLinksDisclosure = $('<div>').append($('<a>', {
                'class': 'odf-link ' + options.linkFontSizeModifierClass,
                'href': linkDisclosure.link,
                'target': '_blank',
                'html': linkDisclosure.text,
            }));
            $popupLinksDisclosure.on(Odigeo.Events.tap, function(e) {
                e.stopPropagation();
                sendTracking('disclosure');
            });
            $firstLinkContainer.append($popupLinksDisclosure);
        }

        $popupExclusions = $('<div>', {'class': 'od-modal-popupinfo ' + options.popupExclusionsModifierClass,
            'html': content.translations.exclusions});

        $popupContentTitle ? $popupContent.append($popupContentTitle, $popupIntro, $secondLinkContainer, $popupExclusions) :
            $popupContent.append($popupIntro, $secondLinkContainer, $popupExclusions);

        // Dual contract
        if (content.dualcontract.enabled) {
            addDualContract();
        }

        $popupContent.append($firstLinkContainer);

        // Popup Opacity Layer
        $popupOpacityLayer = $('<div>', {'class': 'od-modals-popup-bottom-opacitylayer'});
        $popupContent.append($popupOpacityLayer);

        $wrapper.append($popupTitle, $popupContent);

        return $wrapper;
    };
}());
